import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "tool" }
const _hoisted_2 = ["tooltip"]
const _hoisted_3 = { class: "material-icons btn-icons" }
const _hoisted_4 = { class: "content" }
const _hoisted_5 = ["type", "oninput", "value"]
const _hoisted_6 = { class: "seconday-content" }
const _hoisted_7 = ["tooltip"]
const _hoisted_8 = { class: "material-icons btn-icons" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("span", {
      class: "tooltip",
      tooltip: _ctx.leftTooltip
    }, [
      _createElementVNode("button", {
        class: "button-left pdf-pagination-button",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('leftMethod')))
      }, [
        _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.leftIcon), 1 /* TEXT */)
      ])
    ], 8 /* PROPS */, _hoisted_2),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("input", {
        class: "primary-content",
        type: _ctx.inputType,
        minlength: "1",
        maxlength: "3",
        onfocus: "this.value=''",
        onBlur: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onInputBlur && _ctx.onInputBlur(...args))),
        oninput: _ctx.trimLengthOnInputField,
        value: _ctx.primaryContent,
        onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('update:changePrimaryContent', $event.target.value))),
        onInput: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('update:inputPrimaryContent', $event.target.value)))
      }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_5),
      _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.secondaryContent), 1 /* TEXT */)
    ]),
    _createElementVNode("span", {
      class: "tooltip",
      tooltip: _ctx.rightTooltip
    }, [
      _createElementVNode("button", {
        class: "button-right pdf-pagination-button",
        onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('rightMethod')))
      }, [
        _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.rightIcon), 1 /* TEXT */)
      ])
    ], 8 /* PROPS */, _hoisted_7)
  ]))
}